import React from "react";
import "./CustomModalWeb.scss";
import { IonModal, IonGrid, IonRow, IonCol, IonButton } from "@ionic/react";
import DOMPurify from 'isomorphic-dompurify';

export const CustomModalWeb = (props: any) => {
  const {
    isModalOpen,
    title,
    message_header,
    message_content,
    message,
    buttons,
    contentAlignment = "center",
    contentScroll = "allow",
    size,
    aditionalCssClass,
    backdropDismiss = false,
    footer,
    extraContent
  } = props;

  function createMarkup(content : any) {
      const clean = DOMPurify.sanitize(content);
      return {__html: clean};
  }
  
  return (
    <IonModal
      isOpen={!!isModalOpen}
      cssClass={`custom-modal-web ${size ? size : ""} ${aditionalCssClass}`}
      backdropDismiss={backdropDismiss}
      mode="md"
    >
      <IonGrid className="content-grid">
        {title && (
          <IonRow>
            <IonCol size="12" className="modal-heading">
              <h3 className="modal-heading-content"> {title}</h3>
            </IonCol>
          </IonRow>
        )}
        <IonRow>
          {(message_header || message_content) && (
            <IonCol size="12" className="modal-content">
              <h5>{message_header}</h5>
              <h6>{message_content}</h6>
              {extraContent && 
              <div dangerouslySetInnerHTML={createMarkup(extraContent)}>
              </div>}
            </IonCol>
          )}
          {message && (
            <IonCol size="12" className="modal-content">
              <div dangerouslySetInnerHTML={createMarkup(message)} />
            </IonCol>
          )}
        </IonRow>
        {props.children && (
          <IonRow
            className={`modal-content ${
              contentAlignment ? contentAlignment : ""
            } ${contentScroll ? contentScroll : "allow"}`}
          >
            {props.children}
          </IonRow>
        )}

        <IonRow>
          <IonCol size="12" className="action-button-container">
            {buttons &&
              buttons.map((button: any, index: number) => (
                <IonButton
                  key={`${button.title}_${index}`}
                  disabled={
                    button && button.isDisabled ? button.isDisabled : false
                  }
                  className={`${
                    button.type !== "" &&
                    button.type !== undefined &&
                    button.type !== null
                      ? button.type
                      : ""
                  }`}
                  onClick={button.onClick}
                  data-test={button["data-test-id"] || button.type}
                >
                  {button.title}
                </IonButton>
              ))}
          </IonCol>
        </IonRow>
      </IonGrid>
      {footer && (
            <IonRow  className="footer-box">
            <IonCol size="12" className="footer-heading">
              <h3 className="footer-heading-content"> {footer()}</h3>
            </IonCol>
          </IonRow> 
        )}
    </IonModal>
  );
};
